const dialog = [
    {
        selector: '[data-js=dialog-trigger]',
        path: { filename: 'dialog' },
    },
];

export { dialog };
